'use client';

import { useState } from 'react';
import { HiChevronDown } from 'react-icons/hi';

import { AsideTests } from 'src/components/AsideTests';
import { BlogPost } from 'src/services/keystone-types';

type Props = {
    items: BlogPost[];
};

export default function AsideAssociatedTests({ items }: Props) {
    const [visible, setVisible] = useState(false);

    return (
        <section className="relative bg-white lg:mb-8">
            <div
                className="bg-primary cursor-pointer p-4 text-white md:px-8 lg:cursor-default"
                onClick={() => setVisible((visible) => !visible)}>
                <h2 className="text-xl">
                    Analize asociate <span className="lg:hidden">({items.length})</span>
                </h2>
                <HiChevronDown
                    aria-hidden
                    className={`absolute right-4 top-4 mt-1 text-2xl transition duration-200 ease-out md:right-8 md:top-8 lg:hidden${
                        visible ? ' rotate-180' : ''
                    }`}
                />
            </div>
            <AsideTests
                className={`${
                    visible ? '' : ' hidden'
                } max-h-[220px] overflow-y-auto p-4 md:px-8 lg:block lg:max-h-none lg:overflow-visible`}
                items={items}
            />
        </section>
    );
}
